export const SET_NETWORK_MODE = "SET_NETWORK_MODE";
